import React from "react";
import "./NotificationsTab.scss";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { InputSwitch } from "primereact/inputswitch";
import { FormActions } from "./FormActions";
import { NotificationsTabViewModel } from "@features/settings/viewmodel/NotificationsTabViewmodel";

export const NotificationsTab: React.FC = () => {
  const {
    loading,
    settings,
    updateSetting,
    handleSave,
    handleCancel,
    apiNotifications,
    updateApiNotification,
  } = NotificationsTabViewModel();

  const header = (
    <div>
      <h2 className="text-xl font-semibold m-0">Notifications</h2>
      <p className="text-gray-600 mt-2">
        You will receive these notifications in the EUcalls app. If you enable
        the corresponding notification setting, you will be notified by email
        too. You may still receive important notifications about your account
        outside of your notification settings.
      </p>
    </div>
  );

  return (
    <div className="settings-notifications">
      <Card className="notif-header-card mb-4" header={header} />

      <Card className="notif-content-card">
        <div className="notif-section">
          {/* API Notifications */}
          {apiNotifications && apiNotifications.length > 0 && (
            <>
              <div className="section-block">
                <div className="section-title">Notification Preferences</div>
                {apiNotifications.map((notification) => (
                  <div key={notification.machine_name} className="toggle-row">
                    <div className="toggle-info">
                      <label
                        onClick={() =>
                          updateApiNotification(
                            notification.machine_name,
                            !notification.enabled,
                          )
                        }
                        className="toggle-label"
                      >
                        {notification.label}
                      </label>
                    </div>
                    <InputSwitch
                      id={notification.machine_name}
                      checked={notification.enabled}
                      onChange={(e) =>
                        updateApiNotification(
                          notification.machine_name,
                          e.value,
                        )
                      }
                    />
                  </div>
                ))}
              </div>

              <Divider />
            </>
          )}

          {/* Email notifications */}
          {/* <div className="section-block">
            <div className="section-title">Email notifications</div>
            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Mentions and replies</div>
                <div className="toggle-desc">When someone mentions you or replies to your posts.</div>
              </div>
              <InputSwitch
                checked={settings.emailMentionsReplies}
                onChange={(e) => updateSetting('emailMentionsReplies', e.value)}
              />
            </div>

            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Proposal updates</div>
                <div className="toggle-desc">Status changes, reviews and deadlines.</div>
              </div>
              <InputSwitch
                checked={settings.emailProposalUpdates}
                onChange={(e) => updateSetting('emailProposalUpdates', e.value)}
              />
            </div>

            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">New matches</div>
                <div className="toggle-desc">New partners and call matches.</div>
              </div>
              <InputSwitch
                checked={settings.emailNewMatches}
                onChange={(e) => updateSetting('emailNewMatches', e.value)}
              />
            </div>

            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Weekly summary</div>
                <div className="toggle-desc">A digest with highlights of the week.</div>
              </div>
              <InputSwitch
                checked={settings.emailWeeklySummary}
                onChange={(e) => updateSetting('emailWeeklySummary', e.value)}
              />
            </div>
          </div>

          <Divider /> */}

          {/* In-app notifications */}
          {/* <div className="section-block">
            <div className="section-title">In-app notifications</div>
            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Enable sounds</div>
                <div className="toggle-desc">Play a sound for new notifications.</div>
              </div>
              <InputSwitch
                checked={settings.appEnableSounds}
                onChange={(e) => updateSetting('appEnableSounds', e.value)}
              />
            </div>

            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Show previews</div>
                <div className="toggle-desc">Show message previews when available.</div>
              </div>
              <InputSwitch
                checked={settings.appShowPreviews}
                onChange={(e) => updateSetting('appShowPreviews', e.value)}
              />
            </div>

            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Do not disturb</div>
                <div className="toggle-desc">Silence notifications until turned off.</div>
              </div>
              <InputSwitch
                checked={settings.appDoNotDisturb}
                onChange={(e) => updateSetting('appDoNotDisturb', e.value)}
              />
            </div>
          </div>

          <Divider /> */}

          {/* Marketing */}
          {/* <div className="section-block">
            <div className="section-title">Marketing</div>
            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Product updates</div>
                <div className="toggle-desc">Feature announcements and roadmap updates.</div>
              </div>
              <InputSwitch
                checked={settings.marketingProductUpdates}
                onChange={(e) => updateSetting('marketingProductUpdates', e.value)}
              />
            </div>

            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Newsletters</div>
                <div className="toggle-desc">Occasional newsletters with tips and stories.</div>
              </div>
              <InputSwitch
                checked={settings.marketingNewsletters}
                onChange={(e) => updateSetting('marketingNewsletters', e.value)}
              />
            </div>

            <div className="toggle-row">
              <div className="toggle-info">
                <div className="toggle-label">Research and surveys</div>
                <div className="toggle-desc">Help us improve with feedback requests.</div>
              </div>
              <InputSwitch
                checked={settings.marketingResearch}
                onChange={(e) => updateSetting('marketingResearch', e.value)}
              />
            </div>
          </div> */}
        </div>

        <FormActions
          onSave={handleSave}
          onCancel={handleCancel}
          loading={loading}
        />
      </Card>
    </div>
  );
};
